module.exports = __webpack_public_path__ + "img/humons.f2e6f72f.svg";